type Persistor = { flush: () => Promise<any>; purge: () => Promise<any> };
let ref: Persistor | null = null;
export const setPersistorRef = (p: Persistor) => { ref = p; };
export const getPersistorRef = () => ref;
